import { Component, Input, OnInit, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { DxTreeListComponent } from 'devextreme-angular';
import { LanguageService } from '../../../../../shared/services/language.service';
import { UserService } from '../../../../../shared/services/user.service';
import { DocumentCodeList } from '../../../_api/models/document-code-list';
import { DocumentAdminService } from '../../../_api/services/document-admin.service';
import { DocumentCardService } from '../../../_api/services/document-card.service';

@Component({
  selector: 'app-document-codes',
  templateUrl: './document-codes.component.html',
  styleUrls: ['./document-codes.component.css']
})
export class DocumentCodesComponent implements OnInit {

  @ViewChild(DxTreeListComponent) codeTreeList: DxTreeListComponent;
  dataSourceDocumentCodes: DocumentCodeList[];

  @Input() documentId = 0;
  @Input() usedAsSearchParameters = false;
  @Input() codeTreeListHeight: any;
  @Input() isReadOnly = false;

  @Output() loading = new EventEmitter<boolean>();
  @Output() codesList = new EventEmitter<any>();

  selectedCodes: any[];

  constructor(private userService: UserService, public languageService: LanguageService,
    private documentcardService: DocumentCardService, private documentAdminService: DocumentAdminService) { }

  ngOnInit(): void {
  }

  loadCodes(documentId: number) {
    if (documentId !== undefined && documentId !== 0) {
      this.documentId = documentId;
      this.documentcardService.GetDocumentCodesWithListsOnDocumentId(this.documentId)
        .subscribe((result: any) => { // success path
          this.dataSourceDocumentCodes = result;
          this.setSelectedCodes();
        }, error => { // error path;
        });
    }
  }

  setSelectedCodes(): void {
    this.selectedCodes = [];
    this.dataSourceDocumentCodes.forEach(docCodes => {
      if (docCodes.IsChecked) { this.selectedCodes.push(docCodes.DocumentCodeId); }
    });
  }  

  onCellClick(e) {
    if (e.rowType === 'data' && e.column.dataField === 'DocumentCodeName') {
      if (!this.usedAsSearchParameters && this.documentId !== 0) {
        this.documentcardService.UpdateDocumentCodeLists(this.documentId, e.component.getSelectedRowsData()).toPromise().then(result => {
          this.loadCodes(this.documentId);
        }).catch(error => { // error path;
        });
      } else {
        this.codesList.emit(e.component.getSelectedRowsData());
      }
    }
  }
}
